import { ApiGetRequest } from './api-get-request';
import { ApiParameters } from './api-parameters';
import { TrackingChannel } from '../../enums/tracking-channel';
import { TrackingMetadataValuePair } from '../../interfaces/tracking-metadata-value-pair';

export class OrderRequest extends ApiGetRequest
{
    public constructor( webapiBasepath:string, id?: number | null, 
                         referrer?: string, browser?: string, platform?: string, version?: string, trackingChannel?: TrackingChannel, TrackingMetadataValuePair?: TrackingMetadataValuePair)
    {
        const parameters = new ApiParameters();

        if (id != null)
        {
            parameters.addQueryParameter('id', id);
        }
        if (referrer != null)
        {
            parameters.addQueryParameter('referrer', referrer);
        }
        if (browser != null)
        {
            parameters.addQueryParameter('browser', browser);
        }
        if (platform != null)
        {
            parameters.addQueryParameter('platform', platform);
        }
        if (version != null)
        {
            parameters.addQueryParameter('version', version);
        }
        if (trackingChannel != null)
        {
            parameters.addQueryParameter('trackingChannel', trackingChannel);
        }
        if (TrackingMetadataValuePair != null)
        {
            const meta = JSON.stringify(TrackingMetadataValuePair);
            parameters.addQueryParameter('trackingMetadata', meta);
        }
        
        super('order', parameters, null, webapiBasepath);
    }
}
